var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
export const FIconButton = (_a) => {
    var { mt = 0, variant = "outlined", border, title, textColor } = _a, props = __rest(_a, ["mt", "variant", "border", "title", "textColor"]);
    return (React.createElement(Tooltip, { arrow: true, title: title },
        React.createElement(IconButton, Object.assign({}, props, { sx: { mt, border: "none" } }), props.children)));
};
